import L from "leaflet";

const MarkerIcon = (
  type,
  color,
  isSelected = false,
  cluster,
  isCluster = false,
  selectedInstitution,
  innerIcon = "",
  entity = ""
) => {
  //--- Allow to set an active state (change cluster Icon color) to the cluster via isInCluster
  if (isCluster) {
    let isInCluster = false;
    const clusterChildMarkers = cluster.getAllChildMarkers();
    if (selectedInstitution) {
      for (const clusterChildMarker of clusterChildMarkers) {
        if (clusterChildMarker.options.calc.id === selectedInstitution.id) {
          isInCluster = true;
          //cluster.spiderfy();
        }
      }
    }

    return L.divIcon({
      //--- Cluster icon
      html: `<svg class="cluster-icon" version="1.1" id="PUCE-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 32 38" width="32" height="38" style="enable-background:new 0 0 32 38;" xml:space="preserve">
            <path fill=${
              isInCluster ? "var(--wphf-primary)" : "#434341"
            } id="gauche" d="M16,1.2C7.7,1.3,1,8.1,1,16.4c0,6,3.4,11.2,8.5,13.7h0c2.4,1.2,4.7,3.4,6.5,6.7V1.2z"/>
            <path fill=${
              isInCluster ? "var(--wphf-primary)" : "#434341"
            } id="droite" d="M16.1,1.2C16,1.2,16,1.2,16.1,1.2L16,36.8c0,0,0,0.1,0.1,0.1c1.9-3.4,4.1-5.6,6.6-6.8h0
                c5-2.5,8.5-7.7,8.5-13.7C31.1,8,24.4,1.2,16.1,1.2z"/>
            </svg>
            <div class="cluster-icon__child-count">${cluster.getChildCount()}</div>
            `,
      iconSize: L.point(33, 33, true),
      className: "custom-marker-cluster",
    });
  } else {
    if (entity !== undefined) {
      if (entity?.color?.length === 1) {
        //--- One color marker
        const icon1 = L.divIcon({
          className: `my-custom-pin ${isSelected ? "active" : ""}`,
          iconAnchor: [15, 30],
          labelAnchor: [-6, 0],
          popupAnchor: [0, -36],
          iconSize: [30, 30], // size of the icon
          html: `<svg class="${
            isSelected ? "active" : ""
          } " version="1.1" id="PUCE-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 32 38" width="32" height="38" style="enable-background:new 0 0 32 38;" xml:space="preserve">
                <path fill="${
                  entity.color[0]
                }" id="gauche" d="M16,1.2C7.7,1.3,1,8.1,1,16.4c0,6,3.4,11.2,8.5,13.7h0c2.4,1.2,4.7,3.4,6.5,6.7V1.2z"/>
                <path fill="${
                  entity.color[0]
                }" id="droite" d="M16.1,1.2C16,1.2,16,1.2,16.1,1.2L16,36.8c0,0,0,0.1,0.1,0.1c1.9-3.4,4.1-5.6,6.6-6.8h0
                    c5-2.5,8.5-7.7,8.5-13.7C31.1,8,24.4,1.2,16.1,1.2z"/>
                <circle fill="#FFFFFF" fill="" id="centre" cx="16" cy="16.3" r="5.8"/>
                </svg>
                `,
        });
        return icon1;
      } else if (entity?.color?.length === 2) {
        //--- two color marker
        const icon2 = L.divIcon({
          className: `my-custom-pin ${isSelected ? "active" : ""}`,
          iconAnchor: [15, 30],
          labelAnchor: [-6, 0],
          popupAnchor: [0, -36],
          iconSize: [30, 30], // size of the icon
          html: `<svg class="${
            isSelected ? "active" : ""
          } " version="1.1" id="PUCE-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 32 38" width="32" height="38" style="enable-background:new 0 0 32 38;" xml:space="preserve">
                <path fill="${
                  entity.color[0]
                }" id="gauche" d="M16,1.2C7.7,1.3,1,8.1,1,16.4c0,6,3.4,11.2,8.5,13.7h0c2.4,1.2,4.7,3.4,6.5,6.7V1.2z"/>
                <path fill="${
                  entity.color[1]
                }" id="droite" d="M16.1,1.2C16,1.2,16,1.2,16.1,1.2L16,36.8c0,0,0,0.1,0.1,0.1c1.9-3.4,4.1-5.6,6.6-6.8h0
                    c5-2.5,8.5-7.7,8.5-13.7C31.1,8,24.4,1.2,16.1,1.2z"/>
                <circle fill="#FFFFFF" id="centre" cx="16" cy="16.3" r="5.8"/>
                </svg>
                `,
        });
        return icon2;
      } else if (entity?.color?.length === 3) {
        //--- Three color marker
        const icon3 = L.divIcon({
          className: `my-custom-pin ${isSelected ? "active" : ""}`,
          iconAnchor: [15, 30],
          labelAnchor: [-6, 0],
          popupAnchor: [0, -36],
          iconSize: [30, 30], // size of the icon
          html: `<svg class="${
            isSelected ? "active" : ""
          } " version="1.1" id="PUCE-3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 32 38" width="32" height="38" style="enable-background:new 0 0 32 38;" xml:space="preserve">
                <path fill="${
                  entity.color[0]
                }" id="haut-droit" d="M16,1.2L16,1.2l0,15.1l13,7.5c1.3-2.2,2-4.8,2-7.5C31,8,24.3,1.2,16,1.2z"/>
                <path fill=${
                  entity.color[1]
                } id="haut-gauche" d="M16,1.2C7.7,1.2,1,8,1,16.4c0,2.7,0.7,5.3,2,7.5l13-7.5V1.2z"/>
                <path fill=${
                  entity.color[2]
                } id="bas" d="M29,23.9l-13-7.5L3,23.9c1.5,2.6,3.7,4.8,6.4,6.1h0c2.5,1.2,4.7,3.4,6.6,6.8c1.9-3.4,4.1-5.6,6.6-6.8
                    h0C25.3,28.6,27.5,26.5,29,23.9z"/>
                <circle fill="#FFFFFF" id="centre" cx="16" cy="16.3" r="5.8"/>
                </svg>
                `,
        });
        return icon3;
      }
    } else {
      return null;
    }
  }
};

export default MarkerIcon;
